import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  loadingContainer: {
    marginTop: "120px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
  },
  populatingEmbedLabel: {
    textAlign: "center",
    maxWidth: "280px",
    color: capitalDesignTokens.semanticColors.foreground.secondary,
  },
});
